import { render, staticRenderFns } from "./AufgabenVerwaltungBauhof.vue?vue&type=template&id=508578a1&scoped=true"
import script from "./AufgabenVerwaltungBauhof.vue?vue&type=script&lang=js"
export * from "./AufgabenVerwaltungBauhof.vue?vue&type=script&lang=js"
import style0 from "./AufgabenVerwaltungBauhof.vue?vue&type=style&index=0&id=508578a1&prod&scoped=true&lang=css"
import style1 from "./AufgabenVerwaltungBauhof.vue?vue&type=style&index=1&id=508578a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508578a1",
  null
  
)

export default component.exports